import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Report } from '@app/_components/report';
import { ReportService } from '@app/_components/report';
import { AlertService, AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PropertySelectComponent } from '@app/_components/_helpers';
import { MessageService } from 'primeng/api';
import { ConstantService } from '@app/_services/constant.service';
import { ImportExportComponent } from '@app/_components/_helpers/import-export/import-export.component';

@Component({
    selector: 'app-vacancy-report',
    templateUrl: './vacancy-report.component.html',
    styles: [],
    standalone: false
})
export class VacancyReportComponent implements OnInit
{

    // children
    @ViewChild(PropertySelectComponent, { static: true }) propertySelectComponent;

    sampleLink = 'https://s3.us-east-1.amazonaws.com/img.kbmblog.com/import_vacancy_report_sample.xlsx';
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;

    makeEmpty = '';


    report: Report;
    reports: any[] = [];
    columns: any[];
    loading = false;

    // forms
    form1: UntypedFormGroup;
    formLoading = false;
    formAction: String;
    formLabels = [];
    formReadOnly = false;



    /*
    *
    * property-select functions
    *
    */
    shortTermRentalId;

    validationMessages = {
        'startDate': [
            { type: 'required', message: 'Required' },
            { type: 'maxlength', message: '15 characters maximum' }],
        'endDate': [
            { type: 'required', message: 'Required' },
            { type: 'maxlength', message: '15 characters maximum' }],
        'effectiveRate': [
            { type: 'required', message: 'Required' },
            { type: 'maxlength', message: '15 characters maximum' }]
    };
    currentDate: string;
    currentSearchForm: any;


    constructor(
        private authenticationService: AuthenticationService,
        private reportService: ReportService,
        private alertService: AlertService,
        private router: Router,
		public messageService: MessageService,
        private formBuilder: UntypedFormBuilder,
        private constantService: ConstantService) { }

    ngOnInit()
    {
        try
        {


            this.columns = [
                { field: 'locationName', header: 'Location', filterMatchMode: 'contains' },
                { field: 'developmentName', header: 'Development', filterMatchMode: 'contains' },
                { field: 'buildingName', header: 'Building', filterMatchMode: 'contains' },
                { field: 'propertyCode', header: 'Property', filterMatchMode: 'contains' },
                { field: 'vacancyDate', header: 'Vacant', filterMatchMode: 'contains' },
                { field: 'vacancyDay', header: 'Day', filterMatchMode: 'contains' },
                { field: 'vacancyTime', header: 'Time', filterMatchMode: 'contains' }


            ];

            this.formBuild();
			/*this.currentDate = moment.utc(new Date()).format();
            this.findByDate(this.currentDate);*/

        } catch (error)
        {
            console.log(error);
        }
    }

    getLocationName (value: any) {
		if (value) {
			return this.constantService.locations.find(function(item) { 
				return item.locationId == value 
			})?.name;
		}
	};

    formBuild()
    {
        /**
           *
           *
           *
           * FORM
           *
           */

        this.form1 = this.formBuilder.group({
            startDate: [new Date()]
        });
    }
    onRowSelect(event)
    {
        try
        {
            // use this for adding query params
            // this.router.navigate(['report-edit'], { queryParams: { reportId: event.data.reportId } });
            // this.router.navigate(['report-view', event.data.reportId]);
        } catch (error)
        {
            console.log('onRowSelect(' + event + ')' + error);
        }
    }
    onSearchDateChange(event)
    {
        try
        {
            // this.propertySelectComponent.setShortTermRentalId('');
            console.log(moment.utc(Number(event.value)).format());
            //this.findByDate(moment.utc(Number(event.value)).format());
        } catch (error)
        {
            console.log('onRowSelect(' + event + ')' + error);
        }
    }
    /*findByDate(utcSearchDate)
    {
        this.loading = true;

        this.reportService.futureVacancyByDate(utcSearchDate).pipe(first()).subscribe(

            data =>
            {
                console.log('reports are: ' + JSON.stringify(data));
                this.reports = data.data.vacancyReports;
                // console.log('QA: ' + JSON.stringify(this.reports));
            },
            error =>
            {
                console.log('reports LIST!: ' + JSON.stringify(error));
                this.alertService.error(error);
            },
            () =>
            { this.loading = false; }
        );
    }*/

    findByShortTermRentalId(shortTermRentalId)
    {
        this.loading = true;

        this.reportService.futureVacancyByProperty(shortTermRentalId).pipe(first()).subscribe(

            data =>
            {
                
                this.reports = data.data.vacancyReports;
                // this.importExportComponent.exporData(exporttype, this.reports, 'Vacancy Reports');
                
            },
            error =>
            {
                console.log('reports LIST!: ' + JSON.stringify(error));
                this.alertService.error(error);
            },
            () =>
            { this.loading = false; }
        );
    }

    /*
    *
    * property-select functions
    *
    */


    setShortTermRentalId($event)
    {
        console.log($event);
        this.form1.patchValue({ startDate: '' });
        this.shortTermRentalId = $event['shortTermRentalId'];
        this.findByShortTermRentalId(this.shortTermRentalId);
    }

	onSearchSubmit(searchForm: any) {
		// kill the old transformation
		// this.advertisedRateRows = [];

		// store the search
		this.currentSearchForm = searchForm;
		this.runVacancyReport(searchForm);
	}

	runVacancyReport(searchForm) {
		try {
			this.formLoading = true;
			this.reportService.futureVacancyBySearch(searchForm)
				.subscribe(
					res => {
						console.log('runReservationRevenueReport SUCCESS: ' + JSON.stringify(res));
						this.reports = res.data.vacancyReports;
                        //Set map location id and set location name
                        this.reports.forEach(report => {
                            report.locationName = this.getLocationName(report.locationId);
                        });
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

    exportSelected(exporttype: any) {
        this.importExportComponent.exporData(exporttype, this.reports, 'Vacancy Reports');
        }
}
